import { makeKey } from "../../../../../../../../utils/helpers";
import { FlyerDetailPageTabPageDetails } from "../flyer-detail-page-tab-page-details/flyer-detail-page-tab-page-details.component";
import React from "react";
import { FlyerDetailPageTabPagesListProps } from "./flyer-detail-page-tab-pages-list.props";
import { HostContainer } from "./flyer-detail-page-tab-pages-list.styles";
import { withShowIf } from "../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPageOverview } from "../../../../../../types/flyer-detail-data/flyer-detail-data.interface";

export const FlyerDetailPageTabPagesList = withShowIf((props: FlyerDetailPageTabPagesListProps) => {
  const onClickPage = (page: FlyerDetailPageOverview) => () => props.onClickPage(page.id);
  const onDeletePage = (page: FlyerDetailPageOverview) => () => props.onDeletePage(page);

  return (
    <HostContainer>
      {props.pages.map((page: FlyerDetailPageOverview, index: number) => (
        <FlyerDetailPageTabPageDetails
          key={makeKey("flyer-page", index)}
          page={page}
          canDelete={props.canDelete}
          onDeletePage={onDeletePage(page)}
          onClickPage={onClickPage(page)}
        />
      ))}
    </HostContainer>
  );
});
